<template>
  <div>
    <el-color-picker
      size="mini"
      class="theme-picker"
      popper-class="theme-picker-dropdown"
      v-model="theme"
      @change="change"
      :predefine="predefineColors"></el-color-picker>
      <span @click="change(theme)" style="cursor:pointer">自定义皮肤</span>
  </div>
  
</template>

<script>
import Cookies from 'js-cookie'
const version = require('element-ui/package.json').version // element-ui version from node_modules
const ORIGINAL_THEME = '#409EFF' // default color
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      predefineColors: [
        '#F5646C', '#259C6A', '#63D8D2', '#72777D'
      ],
      chalk: '', // content of theme-chalk css
      theme: Cookies.get('client-color') || '#72777D'
    }
  },
  computed: {
    ...mapGetters(['themeName'])
  },
  async created() { 
    if (this.themeName && this.themeName !== 'custom') return
    if (this.predefineColors.indexOf(this.theme) === -1) {
      this.predefineColors.push(this.theme)
    }
    var val = Cookies.get('client-color') || '#72777D'
    var oldVal = Cookies.get('client-color') || '#72777D'
    if (typeof val !== 'string') return
    const themeCluster = this.getThemeCluster(val.replace('#', ''))
    const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))       
    const getHandler = (variable, id) => {
      return () => {
        const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
        const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)

        let styleTag = document.getElementById(id)
        if (!styleTag) {
          styleTag = document.createElement('style')
          styleTag.setAttribute('id', id)
          document.head.appendChild(styleTag)
        }
        styleTag.innerText = newStyle
      }
    }

    if (!this.chalk) {
      const url = '/static/theme-chalk/index.css'
      await this.getCSSString(url, 'chalk')
    }
    const chalkHandler = getHandler('chalk', 'chalk-style')
    chalkHandler()
    
    const styles = [].slice.call(document.querySelectorAll('style'))
      .filter(style => {
        const text = style.innerText
        return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
      })
    styles.forEach(style => {
      const { innerText } = style
      if (typeof innerText !== 'string') return
      style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
    })
    const custom = {
      value: 'custom',
      main: this.theme,
      slideColor: this.theme,
      textColor: '#ffffff',
      slideActiveColor: themeCluster[10],
      headerColor: themeCluster[11],
      name: '自定义皮肤',
      type: 2
    }
    this.$store.dispatch('setCustomTheme', custom)
  },
  methods: {
    async change(val) {
      if (val === '#000000') {
        this.theme = '#000001'
        val= '#000001'
      }
      if (this.predefineColors.indexOf(val) === -1) {
        this.predefineColors.push(val)
      }
      if (typeof val !== 'string') return
      var oldVal = Cookies.get('client-color') || '#72777D'
      const themeCluster = this.getThemeCluster(val.replace('#', ''))
      const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))       
      const getHandler = (variable, id) => {
        return () => {
          const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
          const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)

          let styleTag = document.getElementById(id)
          if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.setAttribute('id', id)
            document.head.appendChild(styleTag)
          }
          styleTag.innerText = newStyle
        }
      }

      if (!this.chalk) {
        const url = '/static/theme-chalk/index.css'
        await this.getCSSString(url, 'chalk')
      }
      const chalkHandler = getHandler('chalk', 'chalk-style')
      chalkHandler()

      const styles = [].slice.call(document.querySelectorAll('style'))
        .filter(style => {
          const text = style.innerText
          return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
        })
      styles.forEach(style => {
        const { innerText } = style
        if (typeof innerText !== 'string') return
        style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
      })
      const custom = {
        value: 'custom',
        main: this.theme,
        slideColor: this.theme,
        textColor: '#ffffff',
        slideActiveColor: themeCluster[10],
        headerColor: themeCluster[11],
        name: '自定义皮肤',
        type: 2
      }
      console.log(themeCluster)
      this.$store.dispatch('setCustomTheme', custom) 
    },
    updateStyle(style, oldCluster, newCluster) {
      let newStyle = style
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
      })
      return newStyle
    },

    getCSSString(url, variable) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '')
            resolve()
          }
        }
        xhr.open('GET', url)
        xhr.send()
      })
    },

    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)
        if (tint === 0) { // when primary color is in its rgb space
          return [red, green, blue].join(',')
        } else {
          red += Math.round(tint * (255 - red))
          green += Math.round(tint * (255 - green))
          blue += Math.round(tint * (255 - blue))
          red = red.toString(16)
          green = green.toString(16)
          blue = blue.toString(16)
          return `#${red}${green}${blue}`
        }
      }
      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)
        red = Math.round((1 - shade) * red)
        green = Math.round((1 - shade) * green)
        blue = Math.round((1 - shade) * blue)

        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)
        let returnColor = `#${red}${green}${blue}`        
        return returnColor.length === 7 ? returnColor : '#' + theme
      }
      const clusters = [theme]
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
      }
      clusters.push(shadeColor(theme, 0.1))
      return clusters
    },

    // getThemeCluster(theme) {
    //   const tintColor = (color, tint) => {
    //     let red = parseInt(color.slice(0, 2), 16)
    //     let green = parseInt(color.slice(2, 4), 16)
    //     let blue = parseInt(color.slice(4, 6), 16)

    //     if (tint === 0) { // when primary color is in its rgb space
    //       return [red, green, blue].join(',')
    //     } else {
    //       red += Math.round(tint * (255 - red))
    //       green += Math.round(tint * (255 - green))
    //       blue += Math.round(tint * (255 - blue))

    //       red = red.toString(16)
    //       green = green.toString(16)
    //       blue = blue.toString(16)
    //       return `#${red}${green}${blue}`
    //     }
    //   }

    //   const shadeColor = (color, shade) => {
    //     let red = parseInt(color.slice(0, 2), 16)
    //     let green = parseInt(color.slice(2, 4), 16)
    //     let blue = parseInt(color.slice(4, 6), 16)

    //     red = Math.round((1 - shade) * red)
    //     green = Math.round((1 - shade) * green)
    //     blue = Math.round((1 - shade) * blue)

    //     red = red.toString(16)
    //     green = green.toString(16)
    //     blue = blue.toString(16)

    //     return `#${red}${green}${blue}`
    //   }

    //   const navColor = (color) => {
    //     let red = parseInt(color.slice(0, 2), 16)
    //     let green = parseInt(color.slice(2, 4), 16)
    //     let blue = parseInt(color.slice(4, 6), 16)


    //     console.log(red, green, blue)

    //     red = red.toString(16)
    //     green = green.toString(16)
    //     blue = blue.toString(16)

    //     return `#${red}${green}${blue}`
    //   }

    //   const clusters = [theme]
    //   for (let i = 0; i <= 9; i++) {
    //     clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
    //   }
    //   clusters.push(shadeColor(theme, 0.1))
    //   clusters.push(navColor(theme))
    //   return clusters
    // }
  }
}
</script>

<style>
.theme-picker {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.theme-picker .el-color-picker__trigger {
  vertical-align: middle;
  width: 18px !important;
  height: 18px !important;
  padding: 0px;
  border: none;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
  display: none;
}
</style>
